import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=3d8661d0&"
import script from "./button-group.vue?vue&type=script&lang=js&"
export * from "./button-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8661d0')) {
      api.createRecord('3d8661d0', component.options)
    } else {
      api.reload('3d8661d0', component.options)
    }
    module.hot.accept("./button-group.vue?vue&type=template&id=3d8661d0&", function () {
      api.rerender('3d8661d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/button/src/button-group.vue"
export default component.exports